import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["startAdornment"],
      _excluded2 = ["className", "InputLabelProps", "InputProps", "handleComponentDidUpdate", "rows", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment, useState, useEffect } from 'react';
import { TextField as MuiTextField } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => createStyles({
  disabled: _objectSpread({
    color: theme.palette.text.secondary
  }, theme.props.printRules.textSecondary),
  labelDisabled: {
    '@media print': {
      '&&': _objectSpread({}, theme.props.printRules.textPrimary['@media print'])
    }
  },
  labelShrink: {
    '&&': {
      zIndex: 2,
      transform: 'translate(14px, -2px) scale(0.65)'
    }
  },
  labelRoot: {
    '@media print': {
      '&&': _objectSpread({
        zIndex: 2,
        transform: 'translate(14px, -2px) scale(0.65)',
        background: '#ffffff'
      }, theme.props.printRules.textPrimary['@media print'])
    }
  },
  field: {
    width: '100%',
    marginTop: 0
  },
  outline: {
    marginTop: 2,
    '@media print': {
      borderColor: `${theme.props.printRules.textSecondaryColor} !important`
    },
    '&& > legend > span': {
      padding: 0
    }
  },
  root: _objectSpread({
    padding: '11px 0',
    '&::before': _objectSpread({
      content: '" "',
      position: 'absolute',
      zIndex: 1,
      top: 7,
      left: 10,
      pointerEvents: 'none',
      backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.paper} 15%, ${theme.palette.background.paper}00 25%)`,
      width: 'calc(100% - 50px)',
      height: 22
    }, theme.props.printRules.hide),
    '&::after': _objectSpread({
      content: '" "',
      position: 'absolute',
      zIndex: 1,
      bottom: 11,
      left: 10,
      right: 10,
      pointerEvents: 'none',
      backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.paper}00, ${theme.palette.background.paper} 90%)`,
      width: 'calc(100% - 50px)',
      height: 2
    }, theme.props.printRules.hide)
  }, theme.props.printRules.textPrimary),
  input: {
    padding: '0 46px 0 14px',
    height: '20vmin',
    minHeight: 'calc(4rem + 10px)',
    '@media print': {
      display: 'none'
    }
  },
  inputPrint: {
    display: 'none',
    '@media print': _objectSpread(_objectSpread({
      display: 'inline-block',
      whiteSpace: 'pre-wrap',
      padding: '0px 14px'
    }, theme.props.printRules.textPrimary['@media print']), {}, {
      '&&:empty': {
        height: '20vmin'
      }
    })
  }
}));

const PrintHelper = ({
  startAdornment,
  inputPrintClass,
  value
}) => /*#__PURE__*/React.createElement(Fragment, null, startAdornment || null, /*#__PURE__*/React.createElement("span", {
  className: inputPrintClass,
  "data-testid": "print-helper"
}, value));

export const defaultComponentDidUpdateHandler = (prevValue, currentValue) => prevValue !== currentValue;
/** @component */

export const MultilineTextField = _ref => {
  let {
    className,
    InputLabelProps,
    InputProps: {
      startAdornment
    } = {},
    handleComponentDidUpdate = defaultComponentDidUpdateHandler,
    rows = 3,
    onChange
  } = _ref,
      InputProps = _objectWithoutProperties(_ref.InputProps, _excluded),
      props = _objectWithoutProperties(_ref, _excluded2);

  const classes = useStyles(props);
  const [prevValue, setPrevValue] = useState(props.value);
  const [helperKey, setHelperKey] = useState(prevValue);
  /* eslint-disable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (handleComponentDidUpdate(prevValue, props.value)) {
      setPrevValue(props.value);
    }
  }, [props.value]);
  /* eslint-enable */

  useEffect(() => {
    if (prevValue !== helperKey) {
      setHelperKey(prevValue);
    }
  }, [prevValue, helperKey]);

  const handleChange = e => {
    if (typeof onChange === 'function') {
      onChange(e);
    }

    setPrevValue(e.target.value);
  };

  return /*#__PURE__*/React.createElement(MuiTextField, _extends({
    variant: "outlined",
    multiline: true,
    rows: rows,
    className: `${classes.field}${className ? ` ${className}` : ''}`,
    margin: "normal",
    onChange: handleChange,
    InputLabelProps: _objectSpread({
      classes: {
        disabled: classes.labelDisabled,
        root: classes.labelRoot,
        shrink: classes.labelShrink
      }
    }, InputLabelProps),
    InputProps: _objectSpread({
      classes: {
        root: classes.root,
        input: classes.input,
        notchedOutline: classes.outline,
        disabled: classes.disabled
      },
      startAdornment: /*#__PURE__*/React.createElement(PrintHelper, {
        key: `print-${helperKey}`,
        startAdornment: startAdornment,
        inputPrintClass: classes.inputPrint,
        value: prevValue
      }),
      style: props.style
    }, InputProps)
  }, props));
};
export default MultilineTextField;